<template>
  <multiselect
    v-model="formData"
    :options="config.options || []"
    :preserveSearch="true"
    :showNoResults="false"
    select-label=""
    deselect-label=""
    placeholder="Selecionar Perfil"
    :selected-label="'Selecionado'"
  />
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";

export default {
  name: "SelectAvaliationItemStrategy",
  components: { Multiselect },
  props: {
    value: {},
    avaliationItem: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  methods: {
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    config() {
      return this.avaliationItem.config || {};
    },
  },
}
</script>

